import { render, staticRenderFns } from "./TagPage.vue?vue&type=template&id=78809c4b"
import script from "./TagPage.vue?vue&type=script&lang=js"
export * from "./TagPage.vue?vue&type=script&lang=js"
import style0 from "./TagPage.vue?vue&type=style&index=0&id=78809c4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports